import useStoreDispatch from './useStoreDispatch';

export default useStoreDispatch;
